import React, { useEffect } from "react";
import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import AlertBox from "../../../components/common/AlertBox";
import Logo from "../../../assets/Images/logo.png";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllCreditnotevoucherRegisterReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearCreditnotevoucherRegisterReportList } from "../reportsSlice";
import { formatIndianNumber } from "../../../_helper/helper";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";

const CreditnotevoucherRegisterReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("creditnotevoucherregisterreportState") || "{}"
  );
  const initialValues = JSON.parse(JSON.stringify(state.initialValues));
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .salesmanwisereport-print-break{
          page-break-before: always;
          }
      }
    `;
    document.head.appendChild(style);
  };

  const CreditnotevoucherRegisterReportList = useAppSelector(
    (state) => state.reports.CreditnotevoucherRegisterReportList
  );
  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      from_date: state?.from_date,
      to_date: state?.to_date,
    };
    dispatch(getAllCreditnotevoucherRegisterReport(payload));
    setPrintStyles();

    setTimeout(() => {
      window.print();
    }, 2000);
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("creditnotevoucherregisterreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearCreditnotevoucherRegisterReportList());
    };
  }, []);

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {CreditnotevoucherRegisterReportList && CreditnotevoucherRegisterReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  {/* <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h5 className="m-0 text-center w-100">
                      Credit Note Register Report
                      <>
                        <p style={{ fontSize: 16 }}>
                          For Period :-
                          {state.from_date &&
                            state.to_date &&
                            `( ${moment(state.from_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} )`}
                        </p>
                      </>
                    </Typography.h5>
                  </GridLayoutItem> */}
                  <GridLayoutItem>
                  <ButtonWithLoading
                      buttonStyle={{
                        position: "fixed",
                        right: 0,
                        top: 0,
                        zIndex: 100,
                      }}
                      label={"Print"}
                      className="no-visible-print-btn"
                      type="button"
                      onClick={() => window.print()}
                    />
                    <table
                      className="table table-bordered"
                      style={{ fontSize: "10px", marginBottom: "10px" }}
                    >
                      <tr>
                        <td
                          rowSpan={3}
                          style={{
                            width: "200px",
                            border: "1px solid lightgray",
                          }}
                        >
                          <div style={{ height: "100px" }}>
                            <img
                              src={`${Logo}`}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          HARIHAR FOODS PVT LTD.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          <h6 style={{ margin: 0 }}>Credit Note Register Report </h6>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid lightgray",
                          }}
                        >
                          <p style={{ margin: 0 }}>
                            For Period :{" "}
                            {state.from_date &&
                              state.to_date &&
                              `( ${moment(state.from_date, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )} )`}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print`}
                      // style={{
                      //   width: "fit-content",
                      // }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                          }}
                        >
                          <th style={{ minWidth: 150 }}>Credit Note No</th>

                          {checkInclude("voucher_type", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }}>Voucher Type</th>
                            </>
                          )}
                          {checkInclude("credit_note_voucher_date", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 100 }}>Date</th>
                            </>
                          )}

                          {checkInclude("financial_year", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 100 }}>Financial Year</th>
                            </>
                          )}
                          {checkInclude("ledger_name", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 200 }}>Account Name</th>
                            </>
                          )}

                          {checkInclude(
                            "credit_note_voucher_total_amount",
                            formRenderProps
                          ) && (
                            <>
                              <th style={{ minWidth: 150 }}>Total Amount</th>
                            </>
                          )}
                        </tr>
                      </thead>

                      {/* Table Body */}

                      <tbody>
                        {CreditnotevoucherRegisterReportList.map(
                          (item: any, rowIndex: number) => {
                            return (
                              <>
                                <tr key={rowIndex}>
                                  <td>{item?.credit_note_voucher_no_string}</td>
                                  {checkInclude(
                                    "voucher_type",
                                    formRenderProps
                                  ) && <td>{item?.voucher_type}</td>}
                                  {checkInclude(
                                    "credit_note_voucher_date",
                                    formRenderProps
                                  ) && <td>{item?.credit_note_voucher_date}</td>}
                                  {checkInclude(
                                    "financial_year",
                                    formRenderProps
                                  ) && <td>{item?.financial_year}</td>}
                                  {checkInclude(
                                    "ledger_name",
                                    formRenderProps
                                  ) && <td>{item?.ledger_name}</td>}

                                  {checkInclude(
                                    "credit_note_voucher_total_amount",
                                    formRenderProps
                                  ) && (
                                    <td className="text-end">
                                      {formatIndianNumber(
                                        item?.credit_note_voucher_total_amount || 0
                                      )}
                                    </td>
                                  )}
                                </tr>
                              </>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default CreditnotevoucherRegisterReport;
